import { render, staticRenderFns } from "./crearTarifaIva.vue?vue&type=template&id=6a4f20d2"
import script from "./crearTarifaIva.vue?vue&type=script&lang=js"
export * from "./crearTarifaIva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports